export const latestNewsContent = `
 <a href="https://dublab.es/shows/hedonic-reversal/16-03-22">Listen the latest Hedonic Reversal show (num. 46) for dublab.es</a>. Expect music from Ash Koosha, Nadja, Author & Punisher and many more!
`
